import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceOverview = () => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
              Civil Litigation Excellence
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary to-accent mx-auto rounded-full"></div>
          </div>

          <div className="space-y-8">
            {/* Main Description */}
            <div className="bg-white rounded-2xl p-8 shadow-md border border-border-light">
              <div className="prose prose-lg max-w-none">
                <p className="text-text-secondary leading-relaxed mb-6">
                  Civil litigation forms the cornerstone of dispute resolution in Kenya's legal system. At Peter & Partners Advocates LLP, we demonstrate exceptional courtroom expertise and strategic advocacy that builds client confidence in complex legal proceedings, ensuring the best possible outcomes for our clients.
                </p>
                <p className="text-text-secondary leading-relaxed mb-6">
                  Our civil litigation practice covers a broad spectrum of disputes, from contract disagreements and property conflicts to commercial disputes and appellate proceedings. We combine aggressive advocacy with strategic negotiation skills to achieve favorable resolutions efficiently.
                </p>
                <p className="text-text-secondary leading-relaxed mb-0">
                  Whether pursuing claims or defending against them, our experienced litigation team provides comprehensive representation that protects your interests while exploring all available avenues for resolution, including mediation, arbitration, and full trial proceedings.
                </p>
              </div>
            </div>

            {/* Key Points */}
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-8 border border-primary/10">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
                    <Icon name="Target" size={24} color="white" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                      Why It Matters
                    </h3>
                    <p className="text-text-secondary leading-relaxed">
                      Civil litigation provides the legal framework for resolving disputes when parties cannot reach agreement through negotiation. Skilled representation ensures your rights are protected and interests are vigorously defended.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-secondary/20 to-surface/20 rounded-2xl p-8 border border-secondary/20">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-accent rounded-xl flex items-center justify-center">
                    <Icon name="Compass" size={24} color="white" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                      Our Approach
                    </h3>
                    <p className="text-text-secondary leading-relaxed">
                      We combine thorough case preparation with strategic litigation tactics, always seeking the most efficient path to resolution while maintaining the option for full trial advocacy when necessary.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOverview;